<template>
  <div class="base-panel">

    <div class="step">
      <div class="back">
        <icon-back color="white" @back="gotoList"></icon-back>
      </div>
      <left-steps :data="indexData" :value="current" @change="onChange"></left-steps>
    </div>
    <div class="info">
      <!-- <project-template1 ref="project-template1" v-if="current==0" @next="next"></project-template1> -->
      <step-one v-if="current==0" @next="next" @last="last"></step-one>
      <step-two v-if="current==1" @next="next" @last="last"></step-two>
      <step-three v-if="current==2" @next="next" @last="last" @gotoPage="go"></step-three>
      <step-four v-if="current==3" @next="next" @last="last"></step-four>
      <step-five v-if="current==4" @next="next" @last="last"></step-five>

      <step-six v-if="current==5" @next="next" @last="last"></step-six>
      
      <project-template4 v-if="current==6" @next="next" @last="last"></project-template4>
      <project-template5 v-if="current==7" @next="next" @last="last"></project-template5>
      <project-template6 v-if="current==8" @next="next" @last="last"></project-template6>
      <!-- <project-template2 ref="project-template2" v-if="current==0" @next="next" @last="last"></project-template2> -->
      <!-- <project-template3 ref="project-template3" v-if="current==1" @next="next" @last="last" ></project-template3> -->
      <!-- -->
      <!--  -->
      <!--  -->
    </div>
    <!--      <a-row :gutter="20">-->
    <!--        <a-col :span="4">-->

    <!--        </a-col>-->
    <!--        <a-col :span="current==2||current==3?20:18">-->
    <!--          <project-template1 ref="project-template1" v-if="current==0"></project-template1>-->
    <!--          <project-template2 ref="project-template2" v-if="current==1"></project-template2>-->
    <!--          <project-template3 ref="project-template3" v-if="current==2"></project-template3>-->
    <!--          <project-template4 ref="project-template4" v-if="current==3"></project-template4>-->
    <!--          <project-template5 ref="project-template5" v-if="current==4"></project-template5>-->
    <!--          <div style="margin: 20px;text-align: right">-->
    <!--            <a-button v-if="current>0"  @click="last" style="margin-right: 20px">上一步</a-button>-->
    <!--            <a-button :loading="loading"  type="primary"  @click="next">{{current < 4?'下一步':'确认'}}</a-button>-->
    <!--          </div>-->
    <!--        </a-col>-->
    <!--      </a-row>-->
  </div>
</template>

<script>
import { getAction, postAction } from '@api/manage'
  import StepOne from './StepOne'
  import StepTwo from './StepTwo'
  import StepThree from './StepThree'
  import StepFour from './StepFour'
  import StepFive from './StepFive'
  import StepSix from './StepSix'
  import ProjectTemplate1 from './ProjectTemplate1'
  import ProjectTemplate2 from './ProjectTemplate2'
  import ProjectTemplate4 from './ProjectTemplate4'
  import ProjectTemplate5 from './ProjectTemplate5'
  import LeftSteps from '@views/apppad/projectTemplate/comp/LeftSteps'
  import ProjectTemplate6 from '@views/apppad/projectTemplate/ProjectTemplate6'
  import IconBack from '@comp/Icon/IconBack'
  export default {
    name: 'Index',
    components: { ProjectTemplate6, LeftSteps, StepOne,StepTwo,StepThree,StepFour,StepFive,StepSix, ProjectTemplate1, ProjectTemplate2, ProjectTemplate4, ProjectTemplate5, IconBack },
    data() {
      return {
        model: {},
        id: '',
        current: -1,
        loading: false,
        indexData: [
          { name: '研究科室' },
          { name: '研究病种' },
          { name: '病种模块' },
          { name: '随访表单' },
          { name: '随访周期' },
          { name: '样本计算' },
          { name: '方案成本' },
          { name: '纳排标准' },
          { name: '完成配置' },
        ]
      }
    },
    watch: {
      current() {
        this.$router.push({
          query: {
            id: this.$route.query.id,
            goIndex: this.current
          }
        })
      }
    },
    mounted() {
      this.current = this.$route.query.goIndex ? parseInt(this.$route.query.goIndex + '') : 0
      this.init();
    },
    methods: {
      next() {
        switch (this.current) {
          case 5:
            getAction('/projectconfigview/configProject/check2', { id: this.id }).then(res => {
              if (res.success) {
                this.current += 1
              } else {
                this.$message.error(res.message)
              }
            })
            break
          case 6:
            getAction('/projectconfigview/configProject/check3', { id: this.id }).then(res => {
              if (res.success) {
                this.current += 1
              } else {
                this.$message.error(res.message)
              }
            })
            break
          case 8:
            this.$confirm({
              title: '确认启动吗',
              content: (<div>
                <p>确认启动项目吗？</p>
              </div>),
              centered: false,
              onOk: () => {
                postAction('/projectconfigview/configProject/handleUse', { id: this.id }).then(res => {
                  if (res.success) {
                    this.$router.push(`/pad/projectStartedSuccessfully?id=${res.result.id}`)
                  } else {
                    this.$message.error(res.message)
                  }
                })
              }
            });
            break
          default:
            this.current += 1
            break
        }
      },
      last() {
        this.current = this.current - 1
      },      
      gotoList(){
        this.$router.push({
          path:'/pad/index'
        })
      },
      go(goIndex) {
        this.current = goIndex
      },
      init() {
        this.id = this.$route.query.id
        const id = this.$route.query.id
        if (id) {
          // 回显  不在这里面回显了
        }
      },
      /**
       * 设置顺序点击的
       * @param current
       */
      onChange(current) {
        if (this.current < current) {
          return
        }
        this.current = current
      }
    }
  }
</script>

<style scoped lang="less">
  .base-panel{
    background-color: #1d2132;
    height: 100vh;
    display: flex;
    ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }

    .step{
      width: 92px;
    }
    .info{
      flex: 1;
    }

    .back{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 56px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    }
  }

</style>
